<template>
  <div>
    <dialog-page-search :text.sync="search"/>
    <v-divider/>
    <div>
      <v-row no-gutters>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" fixed-tabs height="54px">
            <v-tab v-for="(v,k) in localCats" :key="k" class="pa-0" style="min-width: 0">
              <dialog-page-nav-tab-item :name="v.name" :icon="v.icon" :count="v.unreadCount" :loading="v.loading"/>
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="auto" align-self="center">
          <v-menu offset-y right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn v-bind="attrs" v-on="on" icon class="mx-1">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <radios
                :select.sync="filterView"
                :items="[{id:'my',name:'Мои чаты'},{id:'all',name:'Чаты всех пользователей'}]"
                class="mb-0"
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-divider/>
      <div v-for="(v,k) in localCats" :key="k">
        <dialog-page-chats
            v-show="tab===k"
            :height="height-48-54-1-1"
            :cat="v"
            :search="search"
            :filterView="filterView"
            :selectChat.sync="localSelectChat"
            @loading="(v1)=>v.loading=v1"
            @unreadCount="(v1)=>v.unreadCount=v1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DialogPageSearch from "./DialogPageSearch.vue";
import Radios from "../../../componentsV2/base/Radios.vue";
import DialogPageChats from "./DialogPageChats.vue";
import DialogPageNavTabItem from "./DialogPageNavTabItem.vue";

export default {
  components: {DialogPageNavTabItem, DialogPageChats, Radios, DialogPageSearch},
  props: ['height','cats','selectChat'],
  data: () => ({
    tab: 0,
    search: null,
    localCats: [],
    filterView: null,
    localSelectChat:null,
  }),
  mounted() {
    this.tab = parseInt(this.$tools.storageGet('dialogPageNav_tab', 0));
    this.filterView = this.$tools.storageGet('dialogPageNav_filterView', {id: 'my', name: 'Мои чаты'});
    this.localCats = [
      {id: 'internal', name: 'МИС', icon: 'mdi-account-tie', unreadCount: 0, loading:false},
      {id: 'queue', name: 'Очередь', icon: 'mdi-account-question', unreadCount: 0, loading:false},
      {id: 'process', name: 'Обработка', icon: 'mdi-account-clock', unreadCount: 0, loading:false},
      {id: 'closed', name: 'Закрытые', icon: 'mdi-account-remove', unreadCount: 0, loading:false},
    ];
  },
  watch: {
    tab() {this.$tools.storageSet('dialogPageNav_tab', this.tab)},
    filterView() {this.$tools.storageSet('dialogPageNav_filterView', this.filterView)},
    cats(){this.localCats = this.cats},
    localCats(){this.$emit('update:cats', this.localCats)},
    selectChat(){this.localSelectChat = this.selectChat},
    localSelectChat(){this.$emit('update:selectChat', this.localSelectChat)},
  },
  methods: {
    /*
    loadPage(cat) {
      cat.state.stateLoading();
      axios.get('/napi/dialog/chat/?cat='+cat.id+(this.$tools.isEmpty(this.search) ? '' : '&q='+this.search))
          .then(r => {
            r.data.forEach(v=> this.onDialogChat(v))
            cat.state.stateSuccess();
          })
          .catch(()=>{
            cat.state.stateError();
          });
    },
    onDialogChat(data, isEvent = false){
      const index = this.chats.findIndex(v => v.id === data.id);
      data.blink = isEvent;

      if(index===-1) this.chats.push(data);
      else this.chats[index] = data;

      if(isEvent)
        setTimeout(()=>{
          const index = this.chats.findIndex(v => v.id === data.id);
          if(index!==-1) this.chats[index].blink = false;
        }, 2000)

      this.chats = this.chats.sort((a, b)=>{
        let a1 = a.dialogMesLast ? 10000+a.dialogMesLast.id : + a.id;
        let b1 = b.dialogMesLast ? 10000+b.dialogMesLast.id : + b.id;
        if(a1===b1) return 0;
        return a1>b1 ? -1 : 1;
      })

      this.cats.forEach((cat, k)=>{
        this.cats[k].unreadCount = this.chats.filter(chat=>chat.cat===cat.id && chat._unreadCount>0).length
      })
    }

     */
  }
}
</script>